import { render, staticRenderFns } from "./PolicyMortgages.vue?vue&type=template&id=4a82e1e9"
import script from "./PolicyMortgages.vue?vue&type=script&lang=ts"
export * from "./PolicyMortgages.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports